module.exports = __webpack_public_path__ + "static/img-hand-spoon-777eb82a96c1699b0fc93cc89f0f4482.jpg";